<template>
	<div>
		<h1 class="title" style="margin-top: 1rem;">Upcoming Tournaments</h1>
		<div class="columns">
			<div class="column"></div>
			<div class="column is-two-thirds-tablet is-half-desktop">
				<tournament-list-detail
					v-for="tournament in upcomingTournaments"
					:key="tournament.id"
					:tournament="tournament"
				/>
			</div>
			<div class="column"></div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import TournamentListDetail from '@/components/TournamentListDetail.vue';

export default {
  name: 'TournamentsHome',
  components: {
    TournamentListDetail
  },
  computed: {
    ...mapState(["upcomingTournaments"])
  }
}
</script>